import { type UseInfiniteQueryOptions, useInfiniteQuery } from '@lumapps/base-api/react-query';

import { directoriesList, userDirectoryQueryKeys, ListParameters } from '../api';

export type UseUserDirectoriesOptions = UseInfiniteQueryOptions;
/**
 * Hook to get the list of all user directories.
 * @returns: a react-query query Object
 */
export const useUserDirectories = (params: ListParameters, options?: UseUserDirectoriesOptions) =>
    useInfiniteQuery({
        ...options,
        queryKey: userDirectoryQueryKeys.list(params),
        queryFn: async ({ pageParam }) => {
            const { data } = await directoriesList({ ...params, cursor: pageParam });

            return data;
        },
        getNextPageParam: (lastPage) => (lastPage?.more ? lastPage?.cursor : undefined),
    });
